<template>
    <v-row>
        <v-col cols="12" v-if="!hideTitle">
            <div class="ob-title">
                {{ $t('entrance.place_of_training') }}
            </div>
        </v-col>
        <v-col cols="12">
            <v-item-group v-model="selectedPlace" multiple class="location-grid">
                <v-item v-for="(item, i) in places" :key="i" v-slot:default="{ active, toggle }">
                    <div class="location-card" :class="{ selected: active }" @click="toggle">
                        <v-img eager :src="item.src" height="110" class="location-img"/>
                        <div class="loc-check" :class="{ 'loc-check--active': active }">
                            <v-icon v-if="active" size="12" color="#fff">mdi-check</v-icon>
                        </div>
                        <div class="loc-label">{{ item.label }}</div>
                    </div>
                </v-item>
            </v-item-group>
        </v-col>
    </v-row>
</template>

<script>

import {mapActions, mapState} from 'vuex'

export default {
    props: {
        hideTitle: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            selectedPlace: [],
        }
    },
    computed: {
        ...mapState(['config']),
        places(vm = this) {
            if (!vm.config) return []
            return vm.config.places.map(place => ({name: place.name, value: place.name, src: place.src, label: vm.placeLabel(place.name)}))
        }
    },
    async mounted() {
        const vm = this
        if (!vm.config) await vm.bindConfig()
        vm.loadPlaces()
    },
    methods: {
        ...mapActions(['bindConfig']),
        loadPlaces() {
            const vm = this
            const places = vm.places.map(place => place.name)
            let myPlaces = []
            vm.account?.places?.forEach(place => {
                myPlaces.push(places.indexOf(place))
            })
            vm.selectedPlace = myPlaces
        }
    },
    watch: {
        account() {
            this.loadPlaces()
        },
        selectedPlace(val) {
            this.$emit('change', val.map(place => this.places[place].name))
        },
    },
}
</script>

<style scoped>

.ob-title {
    font-size: 26px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.location-grid {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.location-card {
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    border: 2px solid transparent;
    cursor: pointer;
    transition: border-color .15s ease;
}

.location-card.selected {
    border-color: var(--v-secondary-base);
}

.location-img {
    width: 100%;
}

.loc-label {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 8px 12px;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    font-size: 14px;
    font-weight: 600;
}

.loc-check {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 2px solid rgba(255, 255, 255, 0.7);
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}

.loc-check--active {
    background: var(--v-secondary-base);
    border-color: var(--v-secondary-base);
}

</style>